/**
 * Select
 */

// Custom
import 'protons';

// Module template
import './_select.twig';

// Import custom sass, includes Bootstrap sass
import './_select.scss';

export const name = 'select';

export function disable() {}

export function enable() {}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};